import React from 'react'
import styled from 'styled-components'

import { Link, LogoOLX } from '@olxbr/ds-web'
import { home } from '../../../config/staticUrl'

const Logo = styled(Link)`
  width: 64px;
  height: 64px;
`
const OLXLogo = props => (
  <Logo href={props.href}>
    <LogoOLX />
  </Logo>
)

OLXLogo.defaultProps = {
  href: home,
}

export default OLXLogo
